import { Workbench, WorkbenchEmpty } from '@ndrc/ui';
import { AppWindow } from '../window/AppWindow';
import { useDesk } from '../desk/context';
import { t } from '../messages';
import { PracticeBoard } from './PracticeBoard';
import './practice.css';
export function PracticePage() {
  const { classId, me, observing, openTeacher } = useDesk();
  return (
    <AppWindow title={t('practice.title')}>
      <Workbench
        title={t('practice.title')}
        description={t('practice.description')}
        actions={
          me.role === 'teacher' && !observing ? (
            <button type="button" onClick={() => openTeacher('practice')}>
              {t('practice.prepare')}
            </button>
          ) : undefined
        }
      >
        {classId ? (
          <PracticeBoard
            key={`${me.id}:${classId}:${observing?.userId ?? ''}`}
            classId={classId}
            teacher={me.role === 'teacher'}
          />
        ) : (
          <WorkbenchEmpty title={t('practice.noClass')} />
        )}
      </Workbench>
    </AppWindow>
  );
}
